import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { theme } from '../../layout/theme';

export const QuickNav = styled.nav`
  position: relative;
  border-bottom: 1px solid ${theme.colors.border.main};

  ${theme.screens.LtMd} {
    display: none;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 ${size(-2.5)};
`;

export const Item = styled.li``;

export const Link = styled.a`
  display: block;
  padding: ${size(1.5)} ${size(2.5)};
  text-decoration: none;
  position: relative;
  z-index: 1;

  &:before {
    content: '';
    top: 5px;
    right: 5px;
    bottom: 5px;
    left: 5px;
    position: absolute;
    opacity: 0;
    transition: 75ms;
    z-index: -1;
    border-radius: 3px;
    background: ${theme.colors.bg.accent};
  }

  &:hover {
    &:before {
      opacity: 1;
    }
  }
`;
